<script setup>
import { viewSalary } from '@/services/payroll.services';

export default {
    data() {
        return {
            showModal: false,
            data: null,
        };
    },
    methods: {
        async handleViewSalary(elem) {
            const { data } = await viewSalary({
                user: elem.id,
                basic_pay: parseInt(elem.basic_pay),
                date: elem.pay_date,
                pay_period_from: elem.pay_period_from,
                pay_period_to: elem.pay_period_to,
            });
            this.data = window.URL.createObjectURL(new Blob([data]));
            this.showModal = true;
        },
        handleShowModal(data) {
            console.log('data: ', data);
            this.showModal = true;
            const html = this.$refs.payslip.innerHTML;
            console.log('html: ', html);
        },
    },
};
</script>

<template>
    <div>
        <Modal v-model="showModal" fullscreen @on-ok="ok" @on-cancel="showModal = false">
            <div ref="payslip">
                <h1>
                    <img
                        src="data:image/png;base64,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"
                    />
                </h1>
                <h1>Payslip</h1>
                <Row>
                    <Col span="3"
                        ><Row><b>Payroll Run</b></Row
                        ><Row>0</Row>
                    </Col>
                    <Col span="3"
                        ><Row><b>Pay Period Cut off</b></Row
                        ><Row>0</Row>
                    </Col>
                    <Col span="3"
                        ><Row><b>Attendance Cut Off</b></Row
                        ><Row>0</Row>
                    </Col>
                </Row>

                <Row>
                    <Card style="width: 100%; margin-top: 20px">
                        <div>
                            <p></p>
                            <h2>Employeee Information</h2>
                            <p></p>
                            <h1>name</h1>
                            <p>email<br /></p>
                            <p>Gross Pay:</p>
                            <p>Basic Pay:</p>
                            <p>Bimonthly Rate:</p>
                            <br />
                        </div>
                    </Card>
                </Row>
                <Row>
                    <Col span="12">
                        <Card style="width: 100%; margin-top: 20px">
                            <div style="height: 630px">
                                <h1><b>Gross Income</b></h1>
                                <h2><b>Work Hours</b></h2>
                                <p>Total Hours Worked:</p>
                                <p>Total Absent Hours:</p>
                                <p>Scheduled Hours:</p>
                                <p>Regular Hours:</p>
                                <p>Special Holiday Hours:</p>
                            </div>
                        </Card></Col
                    >
                    <Col span="1"></Col>
                    <Col span="11">
                        <Row>
                            <Card style="width: 100%; margin-top: 20px">
                                <p>Deductions</p>
                                <div>
                                    <h1><b>Gross Income</b></h1>
                                    <h2><b>Work Hours</b></h2>
                                    <p>Total Hours Worked:</p>
                                    <p>Total Absent Hours:</p>
                                    <p>Scheduled Hours:</p>
                                    <p>Regular Hours:</p>
                                    <p>Special Holiday Hours:</p>
                                </div>
                            </Card>
                        </Row>
                        <Row>
                            <Card style="width: 100%; margin-top: 10px">
                                <p>Taxable Income</p>
                                <div>
                                    <h1><b>Gross Income</b></h1>
                                    <h2><b>Work Hours</b></h2>
                                    <p>Total Hours Worked:</p>
                                    <p>Total Absent Hours:</p>
                                    <p>Scheduled Hours:</p>
                                    <p>Regular Hours:</p>
                                    <p>Special Holiday Hours:</p>
                                </div>
                            </Card>
                        </Row>
                        <Row>
                            <Card style="width: 100%; margin-top: 10px">
                                <p>Net Pay</p>
                                <div>
                                    Contributions:
                                    <br />
                                    SSS <br />
                                    Philhealth<br />
                                    HDMF <br />
                                    withholdingTax <br />
                                    Net Pay
                                </div>
                            </Card>
                        </Row>
                    </Col>
                </Row>
            </div>
        </Modal>
    </div>
</template>

<style scoped lang="scss"></style>
